module.exports = __webpack_public_path__ + "img/tarj2-2.3854a76a.svg";